import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./features/auth";
import { authApi } from "./features/auth/authApi";
import { occationApi } from "./features/occation/occationApi";
import { emailTemplateApi } from "./features/emailTemplate/emailTemplateApi";
import { userApi } from "./features/users/usersApi";
import { orderApi } from "./features/order/orderApi";
import { crmApi } from "./features/crm/crmApi";
import { cardApi } from "./features/card/cardApi";
import userSlice from "./features/users/usersSlice";
import { planApi } from "./features/creditPlan/planApi";
import { campaignApi } from "./features/campaign/campaignApi";
import { automatedGiftsApi } from "./features/automatedGifts/automatedGiftsApi";
import { bdapApi } from "./features/bdap/bdapApi";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    userSlice: userSlice,
    [authApi.reducerPath]: authApi.reducer,
    [occationApi.reducerPath]: occationApi.reducer,
    [emailTemplateApi.reducerPath]: emailTemplateApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [crmApi.reducerPath]: crmApi.reducer,
    [cardApi.reducerPath]: cardApi.reducer,
    [planApi.reducerPath]: planApi.reducer,
    [campaignApi.reducerPath]: campaignApi.reducer,
    [automatedGiftsApi.reducerPath]: automatedGiftsApi.reducer,
    [bdapApi.reducerPath]: bdapApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      authApi.middleware,
      occationApi.middleware,
      emailTemplateApi.middleware,
      userApi.middleware,
      orderApi.middleware,
      crmApi.middleware,
      cardApi.middleware,
      planApi.middleware,
      campaignApi.middleware,
      automatedGiftsApi.middleware,
      bdapApi.middleware,
    ]),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
